"use client";
import { useEffect, useRef } from "react";

import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin) 

export default function AnchorLink({ children, className="", href }) {
  // アンカーリンク
  const anchorLinkEl = useRef(null)
  useEffect(() => {
    if(anchorLinkEl) {
      anchorLinkEl.current.addEventListener("click", (e:any) => {
        const href = anchorLinkEl.current.getAttribute("href")
        if(href && href.indexOf("#")==0){
          e.preventDefault()
          if(href=="#") {
            gsap.to( window, {
              duration: 1,
              ease: 'power2.inOut',
              scrollTo: {
                y: 0,
                autoKill: false
              }
            });
          } else {
            const targetEl = document.querySelector(`${href}`)
            if(targetEl) {
              gsap.to( window, {
                duration: 1,
                ease: 'power2.inOut',
                scrollTo: {
                  y: targetEl,
                  offsetY:96,
                  autoKill: false
                }
              });
            }
          }
        }
      })
    }
  }, []);
  
  return (
    <a ref={anchorLinkEl} className={className} href={href}>
      {children}
    </a>
  );
}
